import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const LocationModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    columns.push({key:'id', width: 80, sorter:true,title:<Trans>#</Trans>});
    columns.push({key:'supplier.code', dataIndex: ['supplier', 'code'], width: 150, sorter:true,title:<Trans>Supplier Code</Trans>});
    columns.push({key:'name', width: 150, sorter:true,title:<Trans>Name</Trans>});
    columns.push({
        key: 'source',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>FINISHED_PRODUCT</Trans>,
                value: 'FINISHED_PRODUCT',
            },
            {
                label: <Trans>RAW_MATERIAL</Trans>,
                value: 'RAW_MATERIAL',
            }
        ],
        sorter: true,
        width: 150,
        title: <Trans>Type</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'FINISHED_PRODUCT') {
                color = 'green';
                transText = <Trans>FINISHED_PRODUCT</Trans>;
            } else if (text === 'RAW_MATERIAL') {
                color = 'blue';
                transText = <Trans>RAW_MATERIAL</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });

    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/locations"
    };
}
export default LocationModel();
